import BarMinimalChartController from './bar_minimal_chart_controller';
import 'chart.js/auto';

export default class extends BarMinimalChartController {
  chartOptionOverrides() {
    const maxValue = Math.max(...this.chartData.datasets.map((dataset) => Math.max(...dataset.data)));
    const minValue = Math.min(...this.chartData.datasets.map((dataset) => Math.min(...dataset.data)));
    const minWithPadding = minValue - minValue / 10;

    return {
      maintainAspectRatio: false,
      scales: {
        y: {
          grace: 0,
          border: {
            display: false,
          },
          beginAtZero: false,
          max: maxValue,
          min: minWithPadding,
          ticks: {
            callback: this.ticksFormat(),
            maxTicksLimit: 2,
          },
        },
        x: {
          display: true,
          border: {
            display: false,
          },
          grid: {
            display: false,
          },
        },
      },
    };
  }
}
